import React from "react";
import { useRouteMatch, Link } from "react-router-dom";
const NavLink = ({
  to,
  activeOnlyWhenExact,
  label,
  children,
  special,
  alert,
}) => {
  let match = useRouteMatch({
    path: to,
    exact: activeOnlyWhenExact,
  });
  return (
    <div className={match ? "item active" : "item"}>
      <span>
        <Link to={to} className={special ? special : ""}>
          {label}
        </Link>
        {children}
      </span>
      {alert ? <div className="badge">{alert}</div> : null}
    </div>
  );
};

export default NavLink;
